module.exports = "<div class=\"notification-panel\" [ngClass]=\"isShown?'shown':''\">\n  <span class=\"notification-title\">{{notification?.subject}}</span>\n  <p>{{notification?.body}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/notification/notification.component.html
// module id = ../../../../../src/app/shared/components/notification/notification.component.html
// module chunks = main